import React, { useState } from "react";
import {Button, Form, Container, Alert, Spinner, Card, InputGroup} from "react-bootstrap";
import {fetchAudibleReviewData} from "../../http/bookAPI";


const AudibleReviewParser = ({ onExtract, setCurrentStep }) => {
    const [inputUrl, setInputUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchReviewData = async () => {
        if (!inputUrl.trim()) {
            setError("Please enter a valid Audible review URL.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const data = await fetchAudibleReviewData(inputUrl);

            // Передаем данные в родительский компонент
            if (onExtract) {
                onExtract(data);
                setCurrentStep('STEP5')
            }
        } catch (e) {
            setError("Error fetching review data. Please check the link.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card className="mt-0 p-3 shadow-sm rounded w-100">
            <Form>
                <InputGroup className="mb-0 border-success">
                    <Form.Control
                        type="text"
                        placeholder="Paste Your Audible Reviewer Page link here..."
                        value={inputUrl}
                        onChange={(e) => setInputUrl(e.target.value)}
                        className="border-success"
                    />

                <Button
                    variant="success"

                    onClick={fetchReviewData}
                    disabled={loading}
                >
                    {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
                </Button>
            </InputGroup>
        </Form>

    {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
</Card>
    );
};

export default AudibleReviewParser;
